//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CategoryLineOfBusinessEnum } from './enums/category-line-of-business-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { AddDocumentTypeCodeRequest } from './models/add-document-type-code-request.model';
import { AddDocumentTypeCodeSetRequest } from './models/add-document-type-code-set-request.model';
import { AddDocumentTypeRequest } from './models/add-document-type-request.model';
import { DocumentTypeCategoryDto } from './models/document-type-category-dto.model';
import { DocumentTypeCodeDto } from './models/document-type-code-dto.model';
import { DocumentTypeCodeSetDto } from './models/document-type-code-set-dto.model';
import { DocumentTypeDetailDto } from './models/document-type-detail-dto.model';
import { DocumentTypeDto } from './models/document-type-dto.model';
import { DocumentTypeRequirementTextDto } from './models/document-type-requirement-text-dto.model';
import { DocumentTypeSearchDto } from './models/document-type-search-dto.model';
import { UpdateDocumentTypeCodeRequest } from './models/update-document-type-code-request.model';
import { UpdateDocumentTypeRequest } from './models/update-document-type-request.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DocumentTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDocumentTypeCategoriesByCLob(clob: CategoryLineOfBusinessEnum | undefined): Observable<DocumentTypeCategoryDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/categories?";
        if (clob === null)
            throw new Error("The parameter 'clob' cannot be null.");
        else if (clob !== undefined)
            url_ += "clob=" + encodeURIComponent("" + clob) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypeCategoriesByCLob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypeCategoriesByCLob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeCategoryDto[]>;
        }));
    }

    protected processGetDocumentTypeCategoriesByCLob(response: HttpResponseBase): Observable<DocumentTypeCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeCategoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDocumentTypeCategories(): Observable<string[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/categories-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentTypeCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentTypeCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDocumentTypeCategories(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchDocumentTypes(searchParams: DocumentTypeSearchDto | undefined): Observable<DocumentTypeDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDto[]>;
        }));
    }

    protected processSearchDocumentTypes(response: HttpResponseBase): Observable<DocumentTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentTypeById(documentTypeId: number): Observable<DocumentTypeDetailDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/{documentTypeId}";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDetailDto>;
        }));
    }

    protected processGetDocumentTypeById(response: HttpResponseBase): Observable<DocumentTypeDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDocumentType(documentTypeId: number, request: UpdateDocumentTypeRequest): Observable<DocumentTypeDetailDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/{documentTypeId}";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDetailDto>;
        }));
    }

    protected processUpdateDocumentType(response: HttpResponseBase): Observable<DocumentTypeDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentTypeRequirementTextById(documentTypeId: number, facilityId: number | null | undefined, associationId: number | null | undefined, getInternalAndExternalDescriptions: boolean | undefined): Observable<DocumentTypeRequirementTextDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/{documentTypeId}/requirements?";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        if (facilityId !== undefined && facilityId !== null)
            url_ += "facilityId=" + encodeURIComponent("" + facilityId) + "&";
        if (associationId !== undefined && associationId !== null)
            url_ += "associationId=" + encodeURIComponent("" + associationId) + "&";
        if (getInternalAndExternalDescriptions === null)
            throw new Error("The parameter 'getInternalAndExternalDescriptions' cannot be null.");
        else if (getInternalAndExternalDescriptions !== undefined)
            url_ += "getInternalAndExternalDescriptions=" + encodeURIComponent("" + getInternalAndExternalDescriptions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypeRequirementTextById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypeRequirementTextById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeRequirementTextDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeRequirementTextDto[]>;
        }));
    }

    protected processGetDocumentTypeRequirementTextById(response: HttpResponseBase): Observable<DocumentTypeRequirementTextDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeRequirementTextDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDocumentType(request: AddDocumentTypeRequest): Observable<DocumentTypeDetailDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDetailDto>;
        }));
    }

    protected processCreateDocumentType(response: HttpResponseBase): Observable<DocumentTypeDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDocumentTypeCodeSet(documentTypeId: number, request: AddDocumentTypeCodeSetRequest): Observable<DocumentTypeCodeSetDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/{documentTypeId}/codesets";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentTypeCodeSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentTypeCodeSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeCodeSetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeCodeSetDto>;
        }));
    }

    protected processAddDocumentTypeCodeSet(response: HttpResponseBase): Observable<DocumentTypeCodeSetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeCodeSetDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDocumentTypeCodes(documentTypeId: number, request: AddDocumentTypeCodeRequest): Observable<DocumentTypeCodeDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/{documentTypeId}/codes";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeCodeDto>;
        }));
    }

    protected processAddDocumentTypeCodes(response: HttpResponseBase): Observable<DocumentTypeCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeCodeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDocumentTypeCode(documentTypeId: number, documentTypeCodeId: number, request: UpdateDocumentTypeCodeRequest): Observable<DocumentTypeCodeDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/{documentTypeId}/codes/{documentTypeCodeId}";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        if (documentTypeCodeId === undefined || documentTypeCodeId === null)
            throw new Error("The parameter 'documentTypeCodeId' must be defined.");
        url_ = url_.replace("{documentTypeCodeId}", encodeURIComponent("" + documentTypeCodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentTypeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentTypeCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeCodeDto>;
        }));
    }

    protected processUpdateDocumentTypeCode(response: HttpResponseBase): Observable<DocumentTypeCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeCodeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeDocumentTypeCode(documentTypeId: number, documentTypeCodeId: number): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/document-types/{documentTypeId}/codes/{documentTypeCodeId}";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        if (documentTypeCodeId === undefined || documentTypeCodeId === null)
            throw new Error("The parameter 'documentTypeCodeId' must be defined.");
        url_ = url_.replace("{documentTypeCodeId}", encodeURIComponent("" + documentTypeCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDocumentTypeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDocumentTypeCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDocumentTypeCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}